import FormTitle from 'components/PageLayout/FormTitle';
import { Button } from 'components/curo-components/common/Button';
import { EnvironmentVariable } from 'enums/curo/EnvironmentVariable';
import { envs } from 'envs';

import styles from './EndPages.module.scss';

const PAGE_TITLE = 'We are sorry';
const PAGE_DESCRIPTION = (
  <p className={styles.descriptionWrapper}>
    Our records indicate that you already have an online account opened.
    <br />
    <br />
    Please contact our loan specialists at{' '}
    <strong>{envs[EnvironmentVariable.CuroContactPhoneNumber]}</strong> (Mon - Fri 9am – 7pm Eastern
    Time, excl. holidays) for assistance with logging into your account.
  </p>
);

interface IExistingAccountWithAnotherEmailOrPhoneProps {
  onButtonClick: () => void;
}

const ExistingAccountWithAnotherEmailOrPhone = ({
  onButtonClick,
}: IExistingAccountWithAnotherEmailOrPhoneProps) => {
  return (
    <>
      <FormTitle title={PAGE_TITLE} subTitle={PAGE_DESCRIPTION} />
      <Button kind="primary" size="form" onClick={onButtonClick}>
        Back to Application
      </Button>
    </>
  );
};

export default ExistingAccountWithAnotherEmailOrPhone;
